import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a0e074e2ab6ae0014b9dc96_1783184632791_49e82b93/mytrading/src/app/page.tsx");
